/** The 8 roles — owner-confirmed 2026-07-16 (docs/03). No legacy roles. */
export const ROLES = [
    'super_admin',
    'admin',
    'cxo',
    'ncd_manager',
    'branch_manager',
    'branch_staff',
    'agent',
    'customer',
    // APPEND ONLY, NEVER INSERT. Role ids are POSITIONAL — seed.ts derives them
    // as `ROLES.map((r, i) => [r, i + 1])` — so putting a role anywhere but the
    // end renumbers every role after it and silently repoints every existing
    // user to the wrong one.
    'locker_manager',
];
/** Human labels for UI. */
export const ROLE_LABELS = {
    super_admin: 'Super Admin',
    admin: 'Admin',
    cxo: 'CXO',
    ncd_manager: 'NCD Manager',
    branch_manager: 'Branch Manager',
    branch_staff: 'Branch Staff',
    agent: 'Agent',
    customer: 'Customer',
    locker_manager: 'Locker Manager',
};
/**
 * Cumulative seniority level — used only for coarse UI ordering and
 * "admin-tier" style checks. Authorization itself is permission-based
 * (see permissions.ts), never level-based.
 */
export const ROLE_LEVEL = {
    super_admin: 7,
    admin: 6,
    cxo: 5,
    ncd_manager: 5,
    branch_manager: 3,
    branch_staff: 2,
    agent: 2,
    customer: 0,
    // Alongside a branch manager: senior on lockers, no reach into the NCD book.
    locker_manager: 3,
};
/** Roles that are internal staff (get the AppShell, not the customer portal). */
export const STAFF_ROLES = ROLES.filter((r) => r !== 'customer');
export function isRole(v) {
    return ROLES.includes(v);
}
//# sourceMappingURL=roles.js.map